(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-age"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boomer-age-carousel')) {
    customElements.define('boomer-age-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this._active) return;
        const track = this.querySelector('.bg-age__cards');
        if (!track) return;
        this._active = true;
        const prev = this.querySelector('[data-direction="prev"]');
        const next = this.querySelector('[data-direction="next"]');
        const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const update = () => {
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        const scroll = direction => {
          const card = track.querySelector('.bg-age__card');
          if (!card) return;
          const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
          track.scrollBy({left: direction * step, behavior: reduced() ? 'auto' : 'smooth'});
        };
        this._controller = new AbortController();
        const signal = this._controller.signal;
        prev.addEventListener('click', () => scroll(-1), {signal});
        next.addEventListener('click', () => scroll(1), {signal});
        track.addEventListener('scroll', update, {passive: true, signal});
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          scroll(event.key === 'ArrowRight' ? 1 : -1);
        }, {signal});
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.bg-age__card');
          if (card && this.contains(card)) {
            track.scrollBy({left: card.getBoundingClientRect().left - track.getBoundingClientRect().left - 4, behavior: 'auto'});
          }
        }, {signal});
        this._observer = new ResizeObserver(update);
        this._observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this._controller?.abort();
        this._observer?.disconnect();
        this._active = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
